export enum SortType{
    NEWEST = 1,
    SLRN_ASC = 2,
    SLRN_DESC = 3,
    ID_ASC = 4,
    ID_DESC = 5,
}